import Execute from "./Execute";
import getCookie from "../utilities/GetCookie";

// @todo fix this and remove comment from webpack
(function ($, Drupal) {
  Drupal.behaviors.sourceCodeScourer = {
    attach(context, settings) {
      if (getCookie("can_source_code_scourer")) {
        Execute();
      }
    },
  };
})(jQuery, Drupal);
